import { Constants } from '@leverege/molten-core';
import GoogleMapsHistoryRendererCreator from "./GoogleMapsHistoryRendererCreator.js";
import GoogleMapsRendererCreator from "./GoogleMapsRendererCreator.js";
import GroupingsRendererCreator from "./GroupingsRendererCreator.js";
import ItemTileEditor from "./ItemTileEditor.js";
import ItemTileModel from "./ItemTileModel.js";
import ItemTileRendererCreator from "./ItemTileRendererCreator.js";
export default {
  install(molten) {
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, GoogleMapsRendererCreator);
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, GoogleMapsHistoryRendererCreator);
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, GroupingsRendererCreator);
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, ItemTileRendererCreator);
    molten.addPlugin('Model', {
      type: ItemTileModel.TYPE,
      model: ItemTileModel
    });
    molten.addPlugin('ModelEditor', {
      type: ItemTileModel.TYPE,
      editor: ItemTileEditor
    });
  }
};